import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import '../../common/css/index.css';

import { Invoice } from './Invoice/Invoice';
import { NotFound } from './NotFound';
import { InvoiceError } from './Invoice/InvoiceError';
import { Root } from './Root';
import { Contact } from './Contact/Contact';
import { Quote } from './Quote/Quote';
import { Statements } from './Contact/Statements';
import { Quotes } from './Contact/Quotes';

export const portalRoutes = [
  {
    path: `/`,
    element: <Root />,
    children: [
      {
        path: `i/:code`,
        element: <Invoice />,
        errorElement: <InvoiceError />,
      },
      {
        path: `c/:code`,
        element: <Contact />,
        errorElement: <InvoiceError />,
        children: [
          {
            path: ``,
            element: <Statements type={ `outstanding` } />,
          },
          {
            path: `paid`,
            element: <Statements type={ `paid` } />,
          },
          {
            path: `quotes`,
            element: <Quotes />,
          },
        ],
      },
      {
        path: `q/:code`,
        element: <Quote />,
      },
      {
        path: `*`,
        element: <NotFound />,
      },
    ],
  },
];

const router = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)(portalRoutes);

export function App() {
  return (
    <RouterProvider router={ router }/>
  );
}
